module.exports = __webpack_public_path__ + "img/6.aed3a881.jpg";